import { render, staticRenderFns } from "./ListPromotionRow.vue?vue&type=template&id=f65b136a&scoped=true"
import script from "./ListPromotionRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListPromotionRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListPromotionRow.vue?vue&type=style&index=0&id=f65b136a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65b136a",
  null
  
)

export default component.exports